<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-b-6 m-r-6'">

    <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">{{title}}</div>
        <!-- <button mat-icon-button>
        <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
      </button> -->
    </div>
    <div class="card-actuation p-l-10 pb-8 header-Atributos outer-border">
        <div class="p-r-10">
            <div>
                <div class="parameter-item-list">
                    <div class="parameter-each file-uploader">
                        <div class="upload-wrapper">
                            <!--<input type="file" class="file-input" #fileUpload accept=".pdf"-->                           
                                   <input type="file" class="file-input" #fileUpload accept="{{FileFormatEnum.TrabajadorControllerDocumento}}"
                                   (change)="onFileChange($event.target.files)" multiple="false">
                            <div class="file-upload">
                                <button mat-raised-button color="accent" class="upload-btn"
                                        (click)="fileUpload.value='';fileUpload.click()">
                                    <mat-icon>cloud_upload</mat-icon>
                                </button>
                            </div>
                            <span class="no-msg">{{chosenFileName}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>